module.exports = new Promise((resolve, reject) => {
      const urlParams = new URLSearchParams(window.location.search);
      const resolvedHost = urlParams.get('panelIssuesList') ?? 'https://panel-issues-list.thoughtriver.com';
      console.log('panelIssuesList', 'Resolved host:', resolvedHost);
      const resolvedUrl = `${resolvedHost}/remoteEntry.js`;

      const script = document.createElement('script');
      script.src = resolvedUrl;
      script.onload = () => {
        const proxy = {
          get: (request) => window['panelIssuesList'].get(request),
          init: (...args) => {
            try {
              return window['panelIssuesList'].init(...args);
            } catch (e) {
              console.log('Remote container already initialized');
            }
          },
        }
        resolve(proxy);
      }

      document.head.appendChild(script);
    });